import { ExternalLink } from 'lucide-react';

/**
 * Le lien vers le site officiel de la fédération.
 *
 * POURQUOI IL EST À CÔTÉ DE LA DISCIPLINE
 * ---------------------------------------------------------------------------
 * Le préréglage dit ce que la fédération impose : les catégories d'âge, les
 * champs de la licence, les mentions réglementaires des courriers. Un club
 * finit toujours par vouloir vérifier à la source — devant un parent qui
 * conteste le groupe de son enfant, devant un contrôle, ou devant un bureau
 * renouvelé qui n'était pas là au moment du choix.
 *
 * Sans ce lien, il cherche dans un moteur et tombe sur le site d'une ligue,
 * d'un comité départemental ou d'un club homonyme. Le texte officiel est chez
 * la fédération, et nulle part ailleurs.
 *
 * LA RACINE DU SITE, ET NON UNE PAGE DE RÈGLEMENT
 * ---------------------------------------------------------------------------
 * Un lien profond vers une annexe datée a une durée de vie d'une saison : la
 * fédération refond son site et le lien mène à une erreur — sur laquelle le
 * club se retrouve seul, en pleine question réglementaire, avec l'impression
 * que le logiciel raconte n'importe quoi. Le domaine, lui, ne bouge pas.
 *
 * PAS DE LIEN PLUTÔT QU'UN LIEN MORT
 * ---------------------------------------------------------------------------
 * Une discipline dont le catalogue ne connaît pas l'adresse — une base semée
 * avant que le préréglage n'existe — n'affiche rien du tout.
 */
export default function LienFederation({
  url,
  className = '',
}: {
  url: string | null | undefined;
  className?: string;
}) {
  if (!url) {
    return null;
  }

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      /*
       * onClick stoppe la propagation : sur la carte du catalogue, ce lien
       * voisine un bouton qui adopte la discipline. Sans cela, cliquer sur
       * « la réglementation » adopterait la discipline en même temps qu'il
       * ouvre l'onglet — une adoption qu'on n'a pas demandée, et qu'il faut
       * ensuite défaire.
       */
      onClick={(e) => e.stopPropagation()}
      className={`inline-flex items-center gap-1 text-xs font-medium text-primary-700 dark:text-primary-300 hover:underline ${className}`}
      title="Le site officiel de la fédération : règlements, catégories et textes de référence"
    >
      La réglementation officielle
      <ExternalLink className="w-3 h-3 shrink-0" aria-hidden="true" />
    </a>
  );
}
